module.exports = __webpack_public_path__ + "img/markt-download-8c.8a8cea26.png";